import {
  INSURANCE_TYPES_QUERY,
  ACTIVITY_TYPES_QUERY,
  FINANCING_TYPES_QUERY,
  CURRENCY_QUERY,
  DOCUMENT_STATES_QUERY,
  VISIBILITY_LEVELS_QUERY,
  PROPERTY_DETAILS,
  DOCUMENT_ALLOWED_TRANSITIONS_QUERY,
  DOCUMENT_HEADER_QUERY
} from "features/insuranceDocument/queries/insuranceDocumentQueries";
import { INSURANCE_DOCUMENT_LIST_QUERY } from "features/insuranceDocument/list/queries";
import { OFFER_TYPES_QUERY } from "features/insuranceDocument/edit/general/generalData/queries";
import {
  ENGINE_TYPES_QUERY,
  REGISTRATION_TYPES_QUERY,
  ASSET_CATEGORIES_QUERY,
  ASSET_SUBCATEGORIES_QUERY,
  EQUIPMENT_QUERY
} from "features/insuranceDocument/edit/general/asset/queries";
import { ASSET_TYPES_QUERY } from "features/policyRenewal/queries";
import { INSURED_PERIODS_QUERY, INSURERS_QUERY } from "features/insuranceDocument/edit/general/insuranceData/queries";
import { INSURANCE_CONVENTIONS } from "features/insuranceDocument/edit/offer/casco/queries";
import {
  PARTNER_TYPES_QUERY,
  USAGE_TYPES_QUERY,
  COUNTIES_QUERY
} from "features/insuranceDocument/edit/general/partner/queries";
import { USER_DATA_QUERY } from "hooks/useAuthUserData";
import { HAS_AUTHORIZATION_QUERY } from "hooks/useAuthorization";
import { PARAM_QUERY } from "hooks/useParams";
import { PAYMENT_TYPES_QUERY } from "features/insuranceDocument/edit/policy/policyData/queries";
import { APPLICATION_FEATURE_FLAG_QUERY } from "hooks/useApplicationFeature";
const getName = query => query.definitions[0].name.value;
const UNBOUND_VALUE_TYPE = "UNBOUND_VALUE_TYPE";
const configurationKeys = [
  {
    query: getName(INSURANCE_TYPES_QUERY),
    type: "InsuranceType"
  },
  {
    query: getName(ACTIVITY_TYPES_QUERY),
    type: "ActivityType"
  },
  {
    query: getName(FINANCING_TYPES_QUERY),
    type: "FinancingType"
  },
  {
    query: getName(DOCUMENT_STATES_QUERY),
    type: "DocumentState"
  },
  {
    query: getName(DOCUMENT_HEADER_QUERY),
    type: "DocumentHeader"
  },
  {
    query: getName(OFFER_TYPES_QUERY),
    type: "OfferType"
  },
  {
    query: getName(ENGINE_TYPES_QUERY),
    type: "EngineType"
  },
  {
    query: getName(EQUIPMENT_QUERY),
    type: "Equipment"
  },
  {
    query: getName(ASSET_TYPES_QUERY),
    type: "AssetType"
  },
  {
    query: getName(PROPERTY_DETAILS),
    type: "PropertyDetail"
  },
  {
    query: getName(REGISTRATION_TYPES_QUERY),
    type: "RegistrationType"
  },
  {
    query: getName(ASSET_CATEGORIES_QUERY),
    type: "AssetCategory"
  },
  {
    query: getName(ASSET_SUBCATEGORIES_QUERY),
    type: "AssetSubcategory"
  },
  {
    query: getName(CURRENCY_QUERY),
    type: "CurrencyType"
  },
  {
    query: getName(INSURED_PERIODS_QUERY),
    type: "InsurancePeriodRange"
  },
  {
    query: getName(INSURERS_QUERY),
    type: "Insurer"
  },
  {
    query: getName(INSURANCE_CONVENTIONS),
    type: "InsuranceConvention"
  },
  {
    query: getName(PARTNER_TYPES_QUERY),
    type: "PartnerType"
  },
  {
    query: getName(USAGE_TYPES_QUERY),
    type: "UsageType"
  },
  {
    query: getName(COUNTIES_QUERY),
    type: "City"
  },
  {
    query: getName(PAYMENT_TYPES_QUERY),
    type: "PaymentType"
  },
  {
    query: getName(USER_DATA_QUERY),
    type: "User"
  },
  {
    query: getName(VISIBILITY_LEVELS_QUERY),
    type: "VisibilityLevel"
  },
  {
    query: getName(DOCUMENT_ALLOWED_TRANSITIONS_QUERY),
    type: "DocumentAllowedTransition"
  },
  {
    query: getName(INSURANCE_DOCUMENT_LIST_QUERY),
    type: UNBOUND_VALUE_TYPE
  },
  {
    query: getName(HAS_AUTHORIZATION_QUERY),
    type: UNBOUND_VALUE_TYPE
  },
  {
    query: getName(PARAM_QUERY),
    type: UNBOUND_VALUE_TYPE
  },
  {
    query: getName(APPLICATION_FEATURE_FLAG_QUERY),
    type: UNBOUND_VALUE_TYPE
  }
];

export { configurationKeys, UNBOUND_VALUE_TYPE };
